import React, { FC } from 'react'
import { SelectWithOther } from 'LibNeo'
import { Validators } from 'Modules'
import { WrappedFormUtils } from 'antd/es/form/Form'
import { FieldNames } from 'Constants/FieldNames'
import { useBgDict } from 'Pages/ibro'
import { BgSelectWithOtherWrapper } from './styled'

type ComponentProps = Omit<React.ComponentProps<typeof SelectWithOther>, 'items' | 'form'> & {
	items?: string[]
	fieldName: string
	form: WrappedFormUtils
	lockedFields?: FieldNames[]
	value?: never
	onChange?: never
	errorText?: never
}

export const BgSelectWithOther: FC<Partial<ComponentProps>> = (props) => {
	const { allowedSymbols } = useBgDict()

	const { form, fieldName, lockedFields, items = [] } = props
	const hasErr = fieldName ? Boolean(form?.getFieldError(fieldName)) : false
	return (
		<BgSelectWithOtherWrapper hasErr={hasErr}>
			<SelectWithOther
				{...(props as ComponentProps)}
				items={items}
				fieldOptions={
					props.fieldOptions
						? {
								...props.fieldOptions,
								rules: lockedFields?.includes(fieldName as FieldNames)
									? []
									: [
											allowedSymbols
												? {
														validator: Validators.checkInvalidCharacters({
															payload: {
																allowSymbols: allowedSymbols,
															},
														}),
												  }
												: {},
											...(props.fieldOptions?.rules ?? []),
									  ],
						  }
						: {}
				}
			/>
		</BgSelectWithOtherWrapper>
	)
}
